import { createCookie, getCookie } from '../../base/fc-global';
import $ from 'jquery';

const wrapperFixedBaseClasses = 'fixed top-0 right-0 z-[2] w-full';
const wrapperFixedPadClass = 'pt-[85px]';
const wrapperFixedPadHomeClass = 'pt-0';

function applyWrapperFixed($wrapper) {
	const isHome = $('body').hasClass('home');
	$wrapper
		.addClass(wrapperFixedBaseClasses)
		.removeClass(wrapperFixedPadClass)
		.removeClass(wrapperFixedPadHomeClass)
		.addClass(isHome ? wrapperFixedPadHomeClass : wrapperFixedPadClass);
}

function clearWrapperFixed($wrapper) {
	$wrapper.removeClass(`${wrapperFixedBaseClasses} ${wrapperFixedPadClass} ${wrapperFixedPadHomeClass}`);
}

$(function () {

	menuOpen();
	subMenus();
	openSearch();
	mobileMenu();
	pinHeaderFloatingElements();
});


function menuOpen() {

	$('.with-dropdown-menu a').on('mouseenter', function() {
		fullMenuOpenHandler($(this));
	});
	

	const $menu_close_link = $('.close-menu-dropdown');
	if($menu_close_link.length > 0) {
		$menu_close_link.on('focusout', function(e){ 
			e.preventDefault();
			const $menu_burger = $('.menu-burger');
			$menu_burger.trigger('focus');
			fullMenuOpenHandler($menu_burger);
		});
	}
}

function fullMenuOpenHandler($this) {
	const $wrapper = $('.wrapper');
	const transDur = 400;
	const menuTimer = transDur;

	

	if($('.dropdown-menu').is(':visible')){ 
		$('.dropdown-menu').fadeOut();
		if ($('.wp-block-fc-block-fc-core-header').hasClass('was-scrolling')) {
			$('.wp-block-fc-block-fc-core-header').addClass('scrolling'); 
			$('.wp-block-fc-block-fc-core-header').removeClass('is-scrolling');
		}else{
			$('.wp-block-fc-block-fc-core-header').removeClass('is-scrolling');
		}
		
		

		//Vars
		const curPoint = Math.abs(parseInt($('.wrapper').css('top')));

		$wrapper.css('right', '0');
		$wrapper.removeClass('change-opacity');
		setTimeout(function () {
			
			clearWrapperFixed($wrapper);
			$(window).scrollTop(curPoint);
			$('.site-footer').css({
				'position': '',
				'top': ''
			});
			$wrapper.css({
				right: '',
				top: '',
			});
		}, menuTimer);

	}else{
		$('.dropdown-menu').fadeIn();
		if ($('.wp-block-fc-block-fc-core-header').hasClass('scrolling')) {
			$('.wp-block-fc-block-fc-core-header').addClass('was-scrolling');
			$('.wp-block-fc-block-fc-core-header').addClass('is-scrolling');
		}
		$('.wp-block-fc-block-fc-core-header').addClass('is-scrolling');

		//Vars
		const curPos = $(window).scrollTop();
		

		//Get top position of footer realtive to the top of the browser window
		const curPointFooter = $('.site-footer').offset().top - $(window).scrollTop();

		$wrapper.addClass('change-opacity');
		applyWrapperFixed($wrapper);
		$wrapper.css('top', -curPos);
		$('.site-footer').css({
			'position': 'fixed',
			'top': curPointFooter
		});
	}
}

function subMenus() {
	const $dropdown_menu = $('.dropdown-menu');
	if($dropdown_menu.length > 0){
		const $sub_menus = $('.sub-menu', $dropdown_menu);
		if($sub_menus.length > 0) {
			const $parent_links = $('a.parent-link', $dropdown_menu);
			if($parent_links.length > 0) {

				$parent_links.on({
					mouseenter() {
						const $this = $(this);
						subMenuIntent($this, $sub_menus, $parent_links, $dropdown_menu, false);
					},
					mouseleave() {
						//Vars
						const $this = $(this);
						$this.removeClass('still-hovered');
			
						$dropdown_menu.removeClass('timeout-checker');
					},
					focus() {
						const $this = $(this);
						subMenuIntent($this, $sub_menus, $parent_links, $dropdown_menu, true);
					}
				});

			}
		}
	}
}

function subMenuIntent($this, $sub_menus, $parent_links, $dropdown_menu, is_focus) {
	const target_sub_menu = $this.attr('data-sub-menu');
	var $target_sub_menu = false;
	if(typeof target_sub_menu !== 'undefined' && target_sub_menu !== '') {
		$target_sub_menu = $('#' + target_sub_menu);
	}
	$this.addClass('still-hovered');

	setTimeout(function () {
		if($this.hasClass('still-hovered') && !$this.hasClass('parent-active')) {
			$sub_menus.hide();
			$parent_links.removeClass('parent-active');
			if($target_sub_menu) {
				$target_sub_menu.fadeIn();
				if(is_focus) {
					$this.unbind('focusout');
					const $first_link = $('a:first', $target_sub_menu);
					$this.on('focusout', function() {
						$first_link.trigger('focus');
					});
				}

				const $sub_last_link = $('a:last', $target_sub_menu);
				if($sub_last_link.length > 0) {
					const $containing_li = $this.closest('li');
					const $next_li = $containing_li.next('li');
					if($next_li.length > 0) {
						$sub_last_link.unbind('focusout');
						$sub_last_link.on('focusout', function() {
							$('a:first', $next_li).trigger('focus');
						});
					}
				}
			}		
			$this.addClass('parent-active');
			$dropdown_menu.addClass('timeout-checker');
		}
	}, 300);
}


function openSearch(){

	//Open search and lock the screen on click of .search-icon

	$('.search-icon').on('click', function(e) {

		const $wrapper = $('.wrapper');
		e.preventDefault();

		//If search is open, lock the screen
		if($('.search-popup').hasClass('active')) {
			//Vars
			const curPoint = Math.abs(parseInt($('.wrapper').css('top')));
			clearWrapperFixed($wrapper);
			$('.site-footer').css({
				'position': '',
				'top': ''
			});
			$(window).scrollTop(curPoint);
			$('.search-popup').fadeOut();
			$('.search-popup').removeClass('active');
		} else {

			//Vars
			const curPos = $(window).scrollTop();
			//Get top position of footer realtive to the top of the browser window
			const curPointFooter = $('.site-footer').offset().top - $(window).scrollTop();


			$('.search-popup').fadeIn();
			applyWrapperFixed($wrapper);
			$wrapper.css('top', -curPos);
			$('.site-footer').css({
				'position': 'fixed',
				'top': curPointFooter
			});
			$('.search-popup').addClass('active');
			$('#search-field-focus').trigger('focus');
		}
	});

	$('.search-popup__close').on('click', function(e) {

		const $wrapper = $('.wrapper');
		e.preventDefault();

		//Vars
		const curPoint = Math.abs(parseInt($('.wrapper').css('top')));
		clearWrapperFixed($wrapper);
		$(window).scrollTop(curPoint);
		$('.search-popup').fadeOut();
		$('.search-popup').removeClass('active');
		
		$('.search-icon a').trigger('focus');
	});

	$('.search-popup__close').on('focusout', function() {
		$('#search-field-focus').trigger('focus');
	});

	$('.inner-menu-link').on('click', function(e) {
		e.preventDefault();
		const $this = $(this);
		const target = $this.attr('data-menu-link');
		
		$('.sub-menu').hide();
		$('.mobile-menu').addClass('swipe-menu');
		$('#'+target).fadeIn();
	});
	$('.back-to-menu').on('click', function(e) {
		e.preventDefault();
		$('.mobile-menu').removeClass('swipe-menu');
	});
}

function pinHeaderFloatingElements() {
	const $targets = $('.mobile-menu-grow');
	if ($targets.length === 0) {
		return;
	}

	const pinnedItems = [];
	$targets.each(function () {
		pinnedItems.push({
			$el: $(this),
			$placeholder: null,
			pinned: false,
			naturalTop: null
		});
	});

	const getAdminBarOffset = () => ($('#wpadminbar').length > 0 ? $('#wpadminbar').outerHeight() : 0);
	const isMobileViewport = () => window.matchMedia('(max-width: 900px)').matches;
	const getHeaderPaddingTop = () => {
		const headerInner = document.querySelector('.header__inner');
		if (!headerInner) {
			return 0;
		}
		const paddingTop = parseFloat(window.getComputedStyle(headerInner).paddingTop || '0');
		return Number.isNaN(paddingTop) ? 0 : paddingTop;
	};
	const getPinnedTop = (item) => Math.max(item.naturalTop || 0, getAdminBarOffset(), getHeaderPaddingTop());

	const captureNaturalTop = (item) => {
		if (item.pinned || item.naturalTop !== null) {
			return;
		}
		item.naturalTop = item.$el[0].getBoundingClientRect().top;
	};

	const syncPinnedItem = (item) => {
		if (!item.pinned || !item.$placeholder || item.$placeholder.length === 0) {
			return;
		}

		const placeholderRect = item.$placeholder[0].getBoundingClientRect();
		const isMobileMenu = item.$el.hasClass('mobile-menu-grow');
		const nextStyles = {
			width: `${placeholderRect.width}px`,
			top: `${getPinnedTop(item)}px`
		};
		if (isMobileMenu) {
			nextStyles.width = `${placeholderRect.width}px`;
			nextStyles.height = `${placeholderRect.height}px`;
			if (isMobileViewport()) {
				nextStyles.top = `${getAdminBarOffset() + 20}px`;
			}
			nextStyles.right = isMobileViewport()
				? '20px'
				: `${window.innerWidth - placeholderRect.right}px`;
			nextStyles.left = '';
		} else {
			nextStyles.left = `${placeholderRect.left}px`;
			nextStyles.right = '';
		}
		item.$el.css(nextStyles);
	};

	const pinItem = (item) => {
		if (item.pinned) {
			syncPinnedItem(item);
			return;
		}

		const rect = item.$el[0].getBoundingClientRect();
		const computedStyles = window.getComputedStyle(item.$el[0]);
		const computedDisplay = computedStyles.display;
		const $placeholder = $('<span class="header-floating-pin-placeholder" aria-hidden="true"></span>');
		$placeholder.css({
			display: computedDisplay === 'inline' ? 'inline-block' : computedDisplay,
			width: `${rect.width}px`,
			height: `${rect.height}px`,
			marginTop: computedStyles.marginTop,
			marginRight: computedStyles.marginRight,
			marginBottom: computedStyles.marginBottom,
			marginLeft: computedStyles.marginLeft
		});

		item.$el.before($placeholder);
		item.$placeholder = $placeholder;
		const isMobileMenu = item.$el.hasClass('mobile-menu-grow');
		const pinnedStyles = {
			position: 'fixed',
			top: `${getPinnedTop(item)}px`,
			width: `${rect.width}px`,
			height: `${rect.height}px`,
			margin: 0
		};
		if (isMobileMenu) {
			if (isMobileViewport()) {
				pinnedStyles.top = `${getAdminBarOffset() + 20}px`;
			}
			pinnedStyles.right = isMobileViewport()
				? '20px'
				: `${window.innerWidth - rect.right}px`;
		} else {
			pinnedStyles.left = `${rect.left}px`;
		}

		item.$el
			.addClass('is-floating-pinned')
			.css(pinnedStyles);
		item.pinned = true;
	};

	const unpinItem = (item) => {
		if (!item.pinned) {
			return;
		}

		item.$el.removeClass('is-floating-pinned').css({
			position: '',
			top: '',
			left: '',
			right: '',
			width: '',
			height: '',
			margin: ''
		});

		if (item.$placeholder && item.$placeholder.length > 0) {
			item.$placeholder.remove();
		}

		item.$placeholder = null;
		item.pinned = false;
	};

	const updatePinnedState = () => {
		const shouldPin = window.scrollY > 0;
		pinnedItems.forEach((item) => {
			captureNaturalTop(item);
			if (shouldPin) {
				pinItem(item);
			} else {
				unpinItem(item);
			}
		});
	};

	$(window).on('scroll.headerFloatingPins', updatePinnedState);
	$(window).on('resize.headerFloatingPins', () => {
		pinnedItems.forEach((item) => {
			syncPinnedItem(item);
		});
	});

	pinnedItems.forEach((item) => {
		captureNaturalTop(item);
	});
	updatePinnedState();
}

function mobileMenu(){
	$('.inner-menu-link').on('click', function (e) {
		e.preventDefault();

		const $this = $(this);
		const target = '#'+$this.attr('data-target');

		$('.second-menu').find(target).show();
		$('.mobile-menu__top').addClass('swipe-menu');
	});

	$('.back-to-menu').on('click', function (e) {
		e.preventDefault();
		$('.second-menu').find('div').hide();
		$('.mobile-menu__top').removeClass('swipe-menu');
	});
}

function flashViewCookie($flashPopup, flash_references) {
	let sc_flash_notice = getCookie('sc_flash_notice');
	if(sc_flash_notice) {
		sc_flash_notice = sc_flash_notice.split(',');
	} else {
		sc_flash_notice = [];
	}

	$.each(flash_references, function (index, value) {
		if($.inArray(value, sc_flash_notice) === -1) {
			sc_flash_notice.push(value);
		}
	});
	createCookie('sc_flash_notice', sc_flash_notice.join(','), 30);
}
